import hedgeBQ01 from "@/assets/products/hedge-bq01.jpeg";
import hedgeBQ02 from "@/assets/products/hedge-bq02.jpeg";
import hedgeBQ03 from "@/assets/products/hedge-bq03.jpeg";
import hedgeBQ04 from "@/assets/products/hedge-bq04.jpeg";
import hedgeBQ05 from "@/assets/products/hedge-bq05.jpeg";

export interface HedgeProduct {
  id: string;
  name: string;
  sku: string;
  price: number;
  size: string;
  weight: string;
  image: string;
  description: string;
  shopifyVariantId: string;
  features: string[];
}

const DESCRIPTION =
  "Fake Plant Feature Wall / Artificial Green Wall Panel. Size: 1m × 1m. Our Premium Artificial Green Wall is crafted from superior quality, UV-engineered materials that give it a dense and realistic appearance. Choose Supreme Turf Artificial Hedge for a hassle-free solution that adds charm to any indoor or outdoor space.";

const FEATURES = [
  "UV Stabilised – 5-year manufacturer warranty against fading or cracking",
  "100% Outdoor Safe",
  "Panels can be cut to size or shape with scissors",
  "Flexible – Easy around corners & pillars",
  "Approx 3kg per panel",
  "Easy DIY installation",
  "Dense, lifelike foliage",
  "Re-usable & relocatable",
];

export const HEDGE_PRODUCTS: HedgeProduct[] = [
  {
    id: "bq01",
    name: "Artificial Hedge – BQ01",
    sku: "BQ01",
    price: 80,
    size: "1m × 1m",
    weight: "~3kg",
    image: hedgeBQ01,
    description: DESCRIPTION,
    shopifyVariantId: "gid://shopify/ProductVariant/47824498295025",
    features: FEATURES,
  },
  {
    id: "bq02",
    name: "Artificial Hedge – BQ02",
    sku: "BQ02",
    price: 80,
    size: "1m × 1m",
    weight: "~3kg",
    image: hedgeBQ02,
    description: DESCRIPTION,
    shopifyVariantId: "gid://shopify/ProductVariant/47824498393329",
    features: FEATURES,
  },
  {
    id: "bq03",
    name: "Artificial Hedge – BQ03",
    sku: "BQ03",
    price: 80,
    size: "1m × 1m",
    weight: "~3kg",
    image: hedgeBQ03,
    description: DESCRIPTION,
    shopifyVariantId: "gid://shopify/ProductVariant/47824498458865",
    features: FEATURES,
  },
  {
    id: "bq04",
    name: "Artificial Hedge – BQ04",
    sku: "BQ04",
    price: 80,
    size: "1m × 1m",
    weight: "~3kg",
    image: hedgeBQ04,
    description: DESCRIPTION,
    shopifyVariantId: "gid://shopify/ProductVariant/47824498524401",
    features: FEATURES,
  },
  {
    id: "bq05",
    name: "Artificial Hedge – BQ05",
    sku: "BQ05",
    price: 80,
    size: "1m × 1m",
    weight: "~3kg",
    image: hedgeBQ05,
    description: DESCRIPTION,
    shopifyVariantId: "gid://shopify/ProductVariant/47824498622705",
    features: FEATURES,
  },
];
